<script>
import { Bar } from 'vue-chartjs';

export default {
  name: "ConsumePerHeadChart",
  extends: Bar,
  props: {
    chartLabels: {
      type: Array,
      required: true
    },
    chartDataValues: {
      type: Array,
      required: true
    },
    formatDateRange: {
      type: String,
      required: true
    },
    componentKey: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      chartData: {
        labels: this.chartLabels,
        datasets: [
          {
            label: `Consumo por Cabeça (kg) - ${this.formatDateRange}`,
            data: this.chartDataValues,
            backgroundColor: 'rgba(137, 194, 91, 1)',
            borderColor: 'rgba(137, 194, 91, 1)',
            borderWidth: 2,
            barPercentage: 0.75,
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
                ticks: {
                  min: 0,
                  max: null,
                }
              }],
          y: {
            beginAtZero: true,
            title: {
              display: true,
              text: 'kg por cabeça'
            },
            ticks: {
              callback: function(value) {
                return value + ' kg';
              }
            }
          },
          x: {
            title: {
              display: true,
              text: 'Fecha'
            }
          }
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: function(context) {
                return 'Consumo por cabeça: ' + context.parsed.y + ' kg';
              }
            }
          },
          legend: {
            display: false
          }
        }
      }
    }
  },
  computed: {
    shouldUseGrams() {
      // Si no hay datos, mantener kg
      if (!this.chartDataValues || this.chartDataValues.length === 0) {
        return false;
      }
      
      // Encontrar el valor máximo
      const maxValue = Math.max(...this.chartDataValues);
      
      // Si el máximo es menor a 1 kg, usar gramos
      return maxValue < 1;
    },
    convertedData() {
      if (!this.shouldUseGrams) {
        return this.chartDataValues;
      }
      
      // Convertir kg a gramos
      return this.chartDataValues.map(value => value * 1000);
    },
    unitLabel() {
      return this.shouldUseGrams ? 'g' : 'kg';
    },
    unitText() {
      return this.shouldUseGrams ? 'gramos por cabeça' : 'kg por cabeça';
    },
    chartTitle() {
      const unit = this.shouldUseGrams ? 'g' : 'kg';
      return `Consumo por Cabeça (${unit}) - ${this.formatDateRange}`;
    }
  },
  watch: {
    chartDataValues: {
      handler() {
        this.updateChart();
      },
      deep: true
    },
    chartLabels: {
      handler() {
        this.updateChart();
      },
      deep: true
    }
  },
  methods: {
    updateChart() {
      // Actualizar datos convertidos
      this.chartData.labels = this.chartLabels;
      this.chartData.datasets[0].data = this.convertedData;
      this.chartData.datasets[0].label = this.chartTitle;
      

      const maxValue = this.convertedData && this.convertedData.length > 0 
        ? Math.max(...this.convertedData) 
        : 0;
      const yAxisMax = maxValue > 0 ? maxValue * 1.5 : 1;
      
      this.options.scales.yAxes[0].ticks.min = 0;
      this.options.scales.yAxes[0].ticks.max = yAxisMax;
      this.options.scales.y.title.text = this.unitText;
      this.options.scales.y.ticks.callback = (value) => {
        return value + ' ' + this.unitLabel;
      };
      this.options.plugins.tooltip.callbacks.label = (context) => {
        return 'Consumo por cabeça: ' + context.parsed.y + ' ' + this.unitLabel;
      };
      
      // Re-renderizar el gráfico
      this.renderChart(this.chartData, this.options);
    }
  },
  mounted() {
    this.updateChart();
  },
};
</script> 